import { useContext } from "react";
import { PayrollContext } from "../contexts/payrollContext";

export function usePayroll() {
  const context = useContext(PayrollContext);

  return context;
}
